import React from 'react';

export interface SmartTableButtonsProps {
  showColumnSearch: boolean;
  onToggleSearch: () => void;
  onColumnSettings: () => void;
  onRefresh: () => void;
  onAdd?: () => void;
  addable?: boolean;
  /** When true, show Add button greyed out and non-clickable */
  addDisabled?: boolean;
  analyzeButton?: { label: string; onClick: () => void };
  forceEditable?: boolean;
  onFinishEdit?: () => void;
  salaryConfigButton?: { label: string; onClick: () => void };
}

const SmartTableButtons: React.FC<SmartTableButtonsProps> = ({
  showColumnSearch,
  onToggleSearch,
  onColumnSettings,
  onRefresh,
  onAdd,
  addable = false,
  addDisabled = false,
  analyzeButton,
  forceEditable = false,
  onFinishEdit,
  salaryConfigButton,
}) => {
  return (
    <div className="flex gap-3">
      {/* Дэлгэрэнгүй хайлт товч */}
      <button 
        className={`bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white px-4 py-2.5 rounded-lg shadow-sm text-sm font-medium transition-all duration-200 ${showColumnSearch ? 'ring-2 ring-blue-300' : ''}`}
        onClick={() => {
          console.log('🔥 SmartTableButtons: Дэлгэрэнгүй хайлт товч дарагдлаа!');
          console.log('🔥 onToggleSearch function:', onToggleSearch);
          if (onToggleSearch) {
            onToggleSearch();
          } else {
            console.log('❌ onToggleSearch function is not defined!');
          }
        }}
      >
        {showColumnSearch ? 'Хайлт хаах' : '🔍 Дэлгэрэнгүй хайлт'}
      </button>

      {/* Нэмэх товч */}
      {(addable || addDisabled) && (onAdd || addDisabled) && (
        <button
          type="button"
          disabled={addDisabled}
          className={
            addDisabled
              ? 'bg-gray-300 text-gray-500 cursor-not-allowed px-4 py-2.5 rounded-lg shadow-sm text-sm font-medium'
              : 'bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 text-white px-4 py-2.5 rounded-lg shadow-sm text-sm font-medium transition-all duration-200'
          }
          onClick={() => {
            if (addDisabled) return;
            console.log('🔥 SmartTable Add button clicked!');
            console.log('🔥 onAdd function:', onAdd);
            if (onAdd) {
              onAdd();
            } else {
              console.log('❌ onAdd function is not defined!');
            }
          }}
        >
          ➕ Нэмэх
        </button>
      )}

      {/* Багана тохиргоо товч */}
      <button 
        className="bg-gradient-to-r from-gray-500 to-gray-600 hover:from-gray-600 hover:to-gray-700 text-white px-4 py-2.5 rounded-lg shadow-sm text-sm font-medium transition-all duration-200" 
        onClick={() => {
          console.log('🔥 SmartTableButtons: Багана тохиргоо товч дарагдлаа!');
          console.log('🔥 onColumnSettings function:', onColumnSettings);
          if (onColumnSettings) {
            onColumnSettings();
          } else {
            console.log('❌ onColumnSettings function is not defined!');
          }
        }}
      >
        ⚙️ Багана
      </button>

      {/* Сэргээх товч */}
      <button 
        className="bg-gradient-to-r from-gray-500 to-gray-600 hover:from-gray-600 hover:to-gray-700 text-white px-4 py-2.5 rounded-lg shadow-sm text-sm font-medium transition-all duration-200" 
        onClick={() => {
          console.log('🔥 SmartTableButtons: Сэргээх товч дарагдлаа!');
          console.log('🔥 onRefresh function:', onRefresh);
          if (onRefresh) {
            onRefresh();
          } else {
            console.log('❌ onRefresh function is not defined!');
          }
        }}
      >
        🔄 Сэргээх
      </button>

      {/* Цалингийн тохиргоо товч */}
      {salaryConfigButton && (
        <button 
          className="bg-gradient-to-r from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700 text-white px-4 py-2.5 rounded-lg shadow-sm text-sm font-medium transition-all duration-200" 
          onClick={() => {
            console.log('🔥 SmartTableButtons: Цалингийн тохиргоо товч дарагдлаа!');
            console.log('🔥 salaryConfigButton.onClick function:', salaryConfigButton.onClick);
            if (salaryConfigButton.onClick) {
              salaryConfigButton.onClick();
            } else {
              console.log('❌ salaryConfigButton.onClick function is not defined!');
            }
          }}
        >
          ⚙️ Цалингийн тохиргоо
        </button>
      )}

      {/* Анализ товч */}
      {analyzeButton && !forceEditable && (
        <button 
          className="bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded shadow text-sm" 
          onClick={analyzeButton.onClick}
        >
          {analyzeButton.label}
        </button>
      )}

      {/* Дуусгах товч */}
      {forceEditable && onFinishEdit && (
        <button 
          className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded shadow text-sm" 
          onClick={onFinishEdit}
        >
          Дуусгах
        </button>
      )}
    </div>
  );
};

export default SmartTableButtons;
